module.exports = __webpack_public_path__ + "img/6.39daecf7.png";